"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/**
 * Retrieve the apps from Trident.
 */
function _fetchApps() {
  return _fetchApps2.apply(this, arguments);
}
/**
 * Promise the apps on initialization.
 */


function _fetchApps2() {
  _fetchApps2 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var fetchSettings, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetchSettings = {
              method: 'GET',
              mode: 'cors',
              cache: 'no-cache',
              credentials: 'include'
            };
            _context.next = 3;
            return window.fetch("/apps", fetchSettings);

          case 3:
            res = _context.sent;

            if (!res.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", res.json());

          case 8:
            return _context.abrupt("return", res.Error);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchApps2.apply(this, arguments);
}

var fetchAppsPromise = _fetchApps();
/**
 * Return the pre-initialized promise.
 */


var fetchApps = function fetchApps() {
  return fetchAppsPromise;
};

var _default = {
  fetchApps: fetchApps
};
exports["default"] = _default;
//# sourceMappingURL=service.js.map